import './ensureApcConfig';

// Reaching this line means our own bundle loaded and started executing, so
// clear the one-time asset-load-retry flag set in public/index.html — a
// future genuine chunk-load failure should still be allowed to retry.
sessionStorage.removeItem('apcAssetLoadRetry');

// React
import React from 'react';
import ReactDOM from 'react-dom';

// Redux
import { Provider } from 'react-redux';
// import { createStore, applyMiddleware, compose } from 'redux';

// // Redux Thunk for having async action creators
// import thunk from 'redux-thunk';
import store from './store';
// React Spectrum
import SpectrumProvider from '@react/react-spectrum/Provider';

// I18n
import { setLocale, loadTranslations, syncTranslationWithStore } from 'react-redux-i18n';
import { supportedLocales, fallbackLocale } from './i18n/config';
import translations from './i18n/translations';
//AEP tracking 
import AEPTracking from "./comps/aepTracking";
import { initApcAppLogging } from "./registration/logging/registrationLogger";


// Our main App component, and reducers.
import App from './components/App';
import { AppErrorsProvider } from './components/errors';
// import reducers from './reducers';

// Wire up Redux Dev Tools and create the store from our reducers, wire up thunk middleware.
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

// Load translations to Redux, set default locale.
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));

// Check if we are receiving a locale in the query parameter.
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('locale')) {
  const paramLocale = urlParams.get('locale');
  const finalLocale = Object.keys(supportedLocales).includes(paramLocale)
    ? supportedLocales[paramLocale]
    : fallbackLocale;
  localStorage.setItem('i18n_lang', finalLocale);
  store.dispatch(setLocale(finalLocale));
} else {
  store.dispatch(setLocale(localStorage.getItem('i18n_lang') || 'en_US'));
}

// call  aep tracking script
AEPTracking.init();
initApcAppLogging();

ReactDOM.render(
  <Provider store={store}>
    <SpectrumProvider theme="light" scale="medium">
      <AppErrorsProvider>
        <App />
      </AppErrorsProvider>
    </SpectrumProvider>
  </Provider>,
  document.getElementById('root'),
);
